if (!customElements.get('akgl-size-compare')) {
  customElements.define('akgl-size-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const data = JSON.parse(this.querySelector('[data-comparison]').textContent);
      this.labels = data.labels;
      this.products = data.products.map(p => ({...p, sizeIndex:p.options.findIndex(n => /size/i.test(n)), thicknessIndex:p.options.findIndex(n => /thick/i.test(n)), densityIndex:p.options.findIndex(n => /densit|denist/i.test(n))}));
      this.selected = new Set();
      this.size = this.querySelector('[data-size]');
      this.thickness = this.querySelector('[data-thickness]');
      this.dialog = this.querySelector('dialog');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'PKR',maximumFractionDigits:0});
      const sizes = new Map(), thicknesses = new Map();
      this.products.forEach(p => p.variants.forEach(v => {
        if (p.sizeIndex >= 0) {const raw=v.options[p.sizeIndex], key=this.sizeKey(raw); if (!sizes.has(key)) sizes.set(key,this.sizeLabel(raw));}
        if (p.thicknessIndex >= 0) {const raw=v.options[p.thicknessIndex]; thicknesses.set(this.thicknessKey(raw), raw);}
      }));
      if (!sizes.size || !thicknesses.size) return;
      for (const [key,label] of sizes) this.size.add(new Option(label,key));
      for (const key of [...thicknesses.keys()].sort((a,b)=>Number(a)-Number(b))) this.thickness.add(new Option(`${key} ${this.labels.inches}`,key));
      if (thicknesses.has('6')) this.thickness.value='6';
      this.querySelector('.akgl-controls').hidden=false;
      this.querySelectorAll('.akgl-check').forEach(el=>el.hidden=false);
      this.size.addEventListener('change',()=>this.update());
      this.thickness.addEventListener('change',()=>this.update());
      this.querySelector('[data-sort]').addEventListener('change',()=>this.update());
      this.querySelectorAll('[data-compare]').forEach(input=>input.addEventListener('change',()=>{
        const id=input.closest('[data-product]').dataset.product;
        if (input.checked && this.selected.size===3) {input.checked=false;this.querySelector('[data-status]').textContent=this.labels.limit;return;}
        input.checked ? this.selected.add(id) : this.selected.delete(id);
        this.updateCount();
      }));
      this.querySelector('[data-open]').addEventListener('click',()=>{this.renderTable();this.dialog.showModal();});
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
      this.update();
    }
    sizeKey(raw) {const parts=String(raw).match(/\d+(?:\.\d+)?/g);return parts && parts.length>=2 ? parts.slice(0,2).join('x') : String(raw).toLowerCase().replace(/[^a-z0-9]/g,'');}
    sizeLabel(raw) {return String(raw).replace(/''/g,'"').replace(/\s+/g,' ').replace(/\s*x\s*/gi,' × ').trim();}
    thicknessKey(raw) {return String(raw).match(/\d+(?:\.\d+)?/)?.[0] || String(raw);}
    matching(p) {return p.variants.filter(v=>p.sizeIndex>=0 && p.thicknessIndex>=0 && this.sizeKey(v.options[p.sizeIndex])===this.size.value && this.thicknessKey(v.options[p.thicknessIndex])===this.thickness.value);}
    variant(p) {const matches=this.matching(p);return matches.find(v=>v.available)||matches[0];}
    url(p,v) {return v ? `${p.url}?variant=${v.id}` : p.url;}
    density(p,v) {
      if (!v) return this.labels.unavailable;
      if (p.densityIndex >= 0) return v.options[p.densityIndex] || this.labels.confirm;
      const text=String(p.description||'');
      const before=text.match(/\b(\d{2,3}(?:\.\d+)?)\s+(?:density)\b/i);
      const after=text.match(/\bdensity\s*[:=]\s*(\d{2,3}(?:\.\d+)?)\b/i);
      return before?.[1] || after?.[1] || this.labels.confirm;
    }
    warranty(p) {
      const match=String(p.description||'').match(/\b(\d{1,2})\s*[-–]?\s*years?\s+(?:limited\s+)?warranty\b/i);
      return match ? `${match[1]} ${this.labels.years}` : this.labels.confirm;
    }
    update() {
      let matches=0;
      this.products.forEach(p=>{
        const card=this.querySelector(`[data-product="${p.id}"]`),v=this.variant(p);
        if(v) matches++;
        card.querySelector('[data-price]').textContent=v?this.money.format(v.price/100):'—';
        card.querySelector('[data-variant]').textContent=v?v.options.map((o,i)=>i===p.thicknessIndex?`${o} ${this.labels.inches}`:i===p.sizeIndex?this.sizeLabel(o):`${p.options[i]}: ${o}`).join(' · '):`${this.size.selectedOptions[0].text} · ${this.thickness.selectedOptions[0].text}`;
        card.querySelector('[data-density]').textContent=this.density(p,v);
        card.querySelector('[data-warranty]').textContent=this.warranty(p);
        card.querySelector('[data-availability]').textContent=!v?this.labels.unavailable:v.available?this.labels.available:this.labels.sold_out;
        card.querySelectorAll('[data-view],[data-product-link]').forEach(a=>a.href=this.url(p,v));
      });
      this.querySelector('[data-status]').textContent=`${matches}/${this.products.length} ${this.labels.matches}`;
      const sort=this.querySelector('[data-sort]').value;
      const sorted=[...this.products];
      if(sort!=='default') sorted.sort((a,b)=>{const av=this.variant(a),bv=this.variant(b);if(!av)return bv?1:0;if(!bv)return -1;return sort==='asc'?av.price-bv.price:bv.price-av.price;});
      const grid=this.querySelector('.akgl-products');
      sorted.forEach(p=>grid.append(this.querySelector(`[data-product="${p.id}"]`)));
      this.updateCount();
    }
    updateCount() {this.querySelector('[data-count]').textContent=this.selected.size;this.querySelector('[data-open]').disabled=this.selected.size<2;}
    renderTable() {
      const table=this.querySelector('[data-table]');table.replaceChildren();
      const products=this.products.filter(p=>this.selected.has(String(p.id)));
      const head=document.createElement('thead'),hr=document.createElement('tr');
      const empty=document.createElement('th');empty.scope='col';empty.textContent=this.labels.compare||this.labels.choose;hr.append(empty);
      products.forEach(p=>{const th=document.createElement('th');th.scope='col';th.textContent=p.title;hr.append(th);});head.append(hr);table.append(head);
      const body=document.createElement('tbody');
      for(const key of ['size','thickness','density','warranty','price','availability','view']) {
        const row=document.createElement('tr'),heading=document.createElement('th');heading.scope='row';heading.textContent=this.labels[key];row.append(heading);
        products.forEach(p=>{const cell=document.createElement('td'),v=this.variant(p);
          if(key==='view'){const a=document.createElement('a');a.href=this.url(p,v);a.textContent=this.labels.view;cell.append(a);}
          else if(key==='density') cell.textContent=this.density(p,v);
          else if(key==='warranty') cell.textContent=this.warranty(p);
          else cell.textContent=key==='size'?this.size.selectedOptions[0].text:key==='thickness'?this.thickness.selectedOptions[0].text:key==='price'?(v?this.money.format(v.price/100):'—'):!v?this.labels.unavailable:v.available?this.labels.available:this.labels.sold_out;
          row.append(cell);
        });body.append(row);
      }
      table.append(body);this.querySelector('[data-summary]').textContent=`${this.size.selectedOptions[0].text} · ${this.thickness.selectedOptions[0].text}`;
    }
  });
}

